import {
    ORDER_SUCCESS_MOTION_DEFAULTS,
    type OrderSuccessMotionConfig,
} from '~~/layers/base/constants/orderSuccessMotionDefaults'

type OrderSuccessMotionAppConfig = {
    skeletonFadeMs?: number
    timelineRowContentFadeMs?: number
    heroMeta?: Partial<OrderSuccessMotionConfig['heroMeta']>
    stackedPreview?: Partial<Omit<OrderSuccessMotionConfig['stackedPreview'], 'fade' | 'toss'>> & {
        fade?: Partial<OrderSuccessMotionConfig['stackedPreview']['fade']>
        toss?: Partial<OrderSuccessMotionConfig['stackedPreview']['toss']>
    }
}

/**
 * Resolves order-success motion timings from `app.config.orderSuccess` with {@link ORDER_SUCCESS_MOTION_DEFAULTS} fallbacks.
 */
export function useOrderSuccessMotionConfig(): OrderSuccessMotionConfig {
    const appConfig = useAppConfig()
    const overrides = (appConfig as { orderSuccess?: OrderSuccessMotionAppConfig }).orderSuccess

    const defaults = ORDER_SUCCESS_MOTION_DEFAULTS

    return {
        skeletonFadeMs: overrides?.skeletonFadeMs ?? defaults.skeletonFadeMs,
        timelineRowContentFadeMs:
            overrides?.timelineRowContentFadeMs ?? defaults.timelineRowContentFadeMs,
        heroMeta: {
            ...defaults.heroMeta,
            ...overrides?.heroMeta,
        },
        stackedPreview: {
            minRevealHoldFromLoadingMs:
                overrides?.stackedPreview?.minRevealHoldFromLoadingMs ??
                defaults.stackedPreview.minRevealHoldFromLoadingMs,
            minRevealDelayMs:
                overrides?.stackedPreview?.minRevealDelayMs ??
                defaults.stackedPreview.minRevealDelayMs,
            spinnerFadeMs:
                overrides?.stackedPreview?.spinnerFadeMs ?? defaults.stackedPreview.spinnerFadeMs,
            fade: {
                ...defaults.stackedPreview.fade,
                ...overrides?.stackedPreview?.fade,
            },
            toss: {
                ...defaults.stackedPreview.toss,
                ...overrides?.stackedPreview?.toss,
            },
        },
    }
}
